export enum MfaSourceTypeEnum {
    Unconfigured = 0,
    Email = 1,
    Authenticator = 2
}